import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import mobile from "is-mobile";
import uuidv4 from "uuid/v4";
import { classNames } from "react-extras";

export default class InfoTooltip extends Component {
  render() {
    let { helpText, direction } = this.props;
    if (!direction) {
      direction = "right";
    }

    let props = {};
    const isMobile = mobile({ tablet: true });
    if (isMobile) {
      props = {
        clickable: true,
      };
      direction = "bottom";
    }

    const dataID = uuidv4();
    return (
      <>
        <span
          data-tip={helpText}
          data-for={`${dataID}`}
          className={classNames("glyphicon glyphicon-info-sign info-tooltip", this.props.className)}
          {...props}
        />
        <ReactTooltip id={`${dataID}`} place={direction} {...props} effect="solid" html={true} />
      </>
    );
  }
}
